import { Link } from 'react-router-dom'
import { usePostHog } from 'posthog-js/react'
import { greekToLatin } from '@/lib/api'

interface StopHeaderProps {
  lineId: string
  stopName: string
  destination: string
  isFavorite: boolean
  onToggleFavorite: (e?: React.MouseEvent) => void
  lang: 'el' | 'en'
}

export function StopHeader({
  lineId,
  stopName,
  destination,
  isFavorite,
  onToggleFavorite,
  lang
}: StopHeaderProps) {
  const posthog = usePostHog()
  const toLabel = lang === 'el' ? 'προς' : 'to'

  const handleToggleFavorite = (e?: React.MouseEvent) => {
    posthog.capture('stop_favorite_toggled', {
      lineId,
      stopName,
      destination,
      isFavorite: !isFavorite, // the new state after toggle
    })
    onToggleFavorite(e)
  }

  return (
    <div className="stop-header">
      <div className="stop-header-info">
        <div className="stop-header-top">
          <Link to={`/${greekToLatin(lineId).toLowerCase()}`}>
            <span className="stop-header-line">{lineId}</span>
          </Link>
          <span className="stop-header-direction">
            <span className="direction-label">{toLabel}</span>
            <span className="direction-dest">{destination}</span>
          </span>
          <h2 className="stop-header-name">{stopName}</h2>  
        </div>
      </div>
      <button
        className={`stop-header-fav ${isFavorite ? 'is-fav' : ''}`}
        onClick={(e) => handleToggleFavorite(e)}
      >
        {isFavorite ? '⭐' : '☆'}
      </button>
    </div>
  )
}
